import { QueryFunctionContext } from "@tanstack/react-query";
import axios from "axios";

export const MATRIX_SERVICE = {
  async getMatrix({ queryKey }: QueryFunctionContext) {
    const [, searchText] = queryKey;

    const reqBody = {
      params: {
        entityNameSearchString: searchText,
      },
    };

    const { data } = await axios.get("/Admin/UserGroup/AccessMatrix", reqBody);
    return data;
  },

  async updatePermission(body) {
    const { data } = await axios.post(
      "/Admin/UserGroup/AccessMatrixPartialUpdate",
      body,
    );
    return data;
  },

  async getListOfRoles({ queryKey }: QueryFunctionContext) {
    const [, searchText] = queryKey;

    const reqBody = {
      search: {
        text: searchText,
        fieldNames: ["name"],
      },
      sortItems: [
        {
          fieldName: "id",
          direction: 0,
        },
      ],
      filterItems: [
        {
          fieldName: "isDeleted",
          value: false,
        }
      ]
    };
    const { data } = await axios.post("Admin/UserGroup/List", reqBody);
    return data?.items;
  },
};
